import {
	administration,
	administrationRoutes,
} from 'plugins/router/routes/administration'
import { buildings, buildingsRoutes } from 'plugins/router/routes/buildings'
import { changelog } from 'plugins/router/routes/changelog'
import { craftsmanTasks } from 'plugins/router/routes/craftsmanTasks'
import { dashboard } from 'plugins/router/routes/dashboard'
import {
	documentsGroup,
	documentsGroupRoutes,
} from 'plugins/router/routes/documentsGroup'
import { error } from 'plugins/router/routes/error'
import { faq, faqRoutes } from 'plugins/router/routes/faq'
import { dialogFilePreview, imagePreview } from 'plugins/router/routes/global'
import { login, lostPassword, resetPassword } from 'plugins/router/routes/login'
import { loginAs } from 'plugins/router/routes/loginAs'
import { logout } from 'plugins/router/routes/logout'
import modals from 'plugins/router/routes/modals.ts'
import { notes } from 'plugins/router/routes/notes'
import {
	pendingRequests,
	pendingRequestsRoutes,
} from 'plugins/router/routes/pendingRequests.ts'
import {
	personsGroup,
	personsGroupRoutes,
} from 'plugins/router/routes/personsGroup'
import { privacy } from 'plugins/router/routes/privacy'
import { profile, profileRoutes } from 'plugins/router/routes/profile'
import { reviewDocuments } from 'plugins/router/routes/reviewDocuments'
import { sendgreeting } from 'plugins/router/routes/sendgreeting'
import { sitePolicy } from 'plugins/router/routes/sitePolicy'
import type { RouteRecordRaw } from 'vue-router'

const routesFlat = [
	...buildingsRoutes,
	...administrationRoutes,
	...pendingRequestsRoutes,
	...personsGroupRoutes,
	...faqRoutes,
	...documentsGroupRoutes,
	...profileRoutes,
	notes,
	dashboard,
	documentsGroup,
	lostPassword,
	resetPassword,
	login,
	loginAs,
	sitePolicy,
	craftsmanTasks,
	profile,
	logout,
	changelog,
	reviewDocuments,
	imagePreview,
	dialogFilePreview,
	...modals,
]

export { routesFlat }

export const routes: RouteRecordRaw[] = [
	login,
	loginAs,
	administration,
	buildings,
	dashboard,
	documentsGroup,
	sitePolicy,
	personsGroup,
	craftsmanTasks,
	profile,
	privacy,
	sendgreeting,
	logout,
	error,
	changelog,
	faq,
	reviewDocuments,
	pendingRequests,
	...modals,
]
